<template>
  <v-container class="u-pre-wrap">
    <v-row justify="center">
      <v-col cols="11">
        <v-subheader class="text-left text-xl-h4 text-lg-h4 text-md-h5 text-sm-h6">
          {{ courseSyllabus.courseTitle }}
        </v-subheader>
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-container v-if="courseSyllabus.introductionVideo !== null">
        <v-col v-if="$vuetify.breakpoint.width > 800" cols="12">
          <v-container>
            <iframe width="640" height="360" :src="courseSyllabus.introductionVideo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
          </v-container>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width <= 800 && $vuetify.breakpoint.width > 550" cols="12">
          <v-container>
            <iframe width="480" height="270" :src="courseSyllabus.introductionVideo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
          </v-container>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width <= 550" cols="12">
          <v-container>
            <iframe width="256" height="144" :src="courseSyllabus.introductionVideo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
          </v-container>
        </v-col>
      </v-container>
      <v-container v-else>
        <v-spacer />
      </v-container>
      <v-col cols="12">
        <v-btn @click="enroll">
          受講する
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="10">
        <v-subheader> 学習内容 </v-subheader>
        <v-divider />
      </v-col>
      <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.studyContents" />
    </v-row>
    <v-row justify="center">
      <v-col cols="10">
        <v-subheader> 課題内容 </v-subheader>
        <v-divider />
      </v-col>
      <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.taskContent" />
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-subheader> 修了条件 </v-subheader>
        <v-divider />
      </v-col>
      <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.completionRequirements" />
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-subheader> 前提条件 </v-subheader>
        <v-divider />
      </v-col>
      <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.prerequisite" />
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-subheader> 到達目標 </v-subheader>
        <v-divider />
      </v-col>
      <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.attainmentTarget" />
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-subheader> 想定学習時間 </v-subheader>
        <v-divider />
      </v-col>
      <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.estimatedLearningTime" />
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-subheader> 学習期間（スケジュール） </v-subheader>
        <v-divider />
      </v-col>
      <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.schedule" />
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-subheader> 反転授業 </v-subheader>
        <v-divider />
      </v-col>
      <v-col v-if="courseSyllabus.flippedClassroom" class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.flippedClassroom" />
      <v-col v-else class="text-left" cols="9">
        -
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-subheader> 補助教材 </v-subheader>
        <v-divider />
      </v-col>
      <v-col v-if="courseSyllabus.supplementaryTeachingMaterials" class="text-left" style="white-space: pre-wrap" cols="9" v-text="courseSyllabus.supplementaryTeachingMaterials" />
      <v-col v-else class="text-left" cols="9">
        -
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-subheader> 修了証 </v-subheader>
        <v-divider />
      </v-col>
      <v-col v-if="courseSyllabus.certificateOfCompletion" class="text-left" cols="9">
        あり
      </v-col>
      <v-col v-else class="text-left" cols="9">
        なし
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-subheader> バッジ </v-subheader>
        <v-divider />
      </v-col>
      <v-col v-if="courseSyllabus.badge" class="text-left" cols="9">
        あり
      </v-col>
      <v-col v-else class="text-left" cols="9">
        なし
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-subheader> 講師・スタッフ </v-subheader>
        <v-divider />
      </v-col>
      <v-col v-if="$vuetify.breakpoint.width > 500" class="text-left" cols="9">
        <v-row v-for="(instructor, index) in courseSyllabus.instructor" :key="index" align="start">
          <v-col cols="3">
            <div v-for="(photo, i) in facePhotos" :key="i">
              <v-row dense align="center">
                <v-col v-if="i == index">
                  <img :src="photo" width="100" />
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="9">
            <div class="text-h7 text-left" style="white-space: pre-wrap" v-text="instructor" />
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.width <= 500" class="text-left" cols="9">
        <v-row v-for="(instructor, index) in courseSyllabus.instructor" :key="index" align="start">
          <div v-for="(photo, i) in facePhotos" :key="i">
            <v-col v-if="i == index">
              <v-row>
                <v-col>
                  <img :src="photo" width="100" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="text-h7 text-left" style="white-space: pre-wrap" v-text="instructor" />
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import store from '@/store/store'
import repository from '@/store/repository'
import handleApiError from '@/plugins/handleApiError'

export default {
  data () {
    return {
      courseSyllabus: require(`@/assets/courseData/courseSyllabuses/${this.$route.params.courseId}.json`),
      dialog: false,
      res: null
    }
  },
  computed: {
    ...mapState(['view']),
    facePhotos: function () {
      const tmp = []
      const courseId = this.$route.params.courseId
      const imgContext = require.context('@/assets/courseInstructorImg', true, /\.(jpg|jpeg|png)$/)
      this.courseSyllabus.facePhoto.forEach((element) => {
        const address = imgContext(`./${courseId}/${element}`)
        tmp.push(address)
      })
      return tmp
    },
    isSignedIn: function () {
      return repository.isSignedIn()
    }
  },
  methods: {
    async enroll () {
      const courseName = this.$route.params.courseId || ''
      const courseData = require('@/assets/courseData/courseCards.json')
      const course = courseData.find((v) => v.systemName === this.$route.params.courseId)
      const courseId = Number(course.courseId)
      let status = null

      this.$store.commit('setRegistCourseId', courseId)
      repository.setRegistCourseId(courseId)
      if (!this.isSignedIn) {
        this.$router.push(`/sign-in?redirect=${courseName}/unit-list&regist=${courseId}`)
      } else {
        if (this.$route.query.regist || store.state.registCourseId) {
          await this.registerCourse(store.state.registCourseId)
          if (this.res === 2) {
            status = false
          } else {
            status = true
          }
          repository.removeRegistCourseId()
        }
        if (status !== null) {
          this.$router.push({ name: 'Registered', params: { registStatus: status } })
        } else {
          this.$router.push({ name: 'CourseList' })
        }
      }
    },
    async registerCourse (courseId) {
      const reqUrl = process.env.VUE_APP_COURSE_REGISTRATION_API_URL

      const reqBody = {
        pjmUserId: String(repository.getPjmUserId()),
        cognitoIdToken: repository.getIdToken(),
        cognitoUsername: store.state.username,
        courseId: courseId
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      // 講座登録API を叩く
      const result = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      this.res = result.data.registResult
    }
  }
}
</script>
